import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class TabElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  navigationLabel = '';
  title = 'Title';
  subtitle = 'Subtitle';
  content =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
  imageSrc = 'assets/images/builder/placeholders/mountain.png';
  buttonText: string;
  link = new TbLink();
  imageAlignment = 'uk-flex-row';

  constructor(src?: string) {
    this.imageSrc = src;
  }

  static normalizeInPlace(element: TabElement): TabElement {
    const pureElement = new TabElement();

    element.navigationLabel = element.navigationLabel ?? pureElement.navigationLabel;
    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;
    element.imageSrc = element.imageSrc ?? pureElement.imageSrc;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.imageAlignment = element.imageAlignment ?? pureElement.imageAlignment;

    return element;
  }
}
